import { makeStyles } from '@bymason-private/controller-v1-theme-provider';
import { LinkCard, IoPlayCircleOutline, Modal } from '@bymason-private/legacy-pattern-components';
import { useState } from 'react';

const useStyles = makeStyles(() => ({
  sectionEmpty: { width: '100%' },
  cards: {
    paddingTop: 40,
    display: 'flex',
    flexWrap: 'wrap',
    rowGap: 24,
    columnGap: 24,
    justifyContent: 'center',
  },
  background: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundImage: 'url("https://mcdn.bymason.com/runway/controller/empty-state-devices-background.png")',
    backgroundSize: 'cover',
    width: 252,
    height: 138,
  },
  images: {
    width: 160,
  },
  modalContent: {
    width: '90vw',
    maxWidth: '1124px',
    height: '90vh',
    maxHeight: '633px',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
}));

export default function NoDevices() {
  const classes = useStyles();
  const [mediaOpen, setMediaOpen] = useState(false);

  const handleOpenMedia = () => {
    setMediaOpen(true);
  };
  const handleCloseMedia = () => {
    setMediaOpen(false);
  };

  return (
    <section className={classes.sectionEmpty}>
      <div className={classes.cards}>
        <LinkCard
          message='Order a Dev Kit'
          Component={
            <img
              className={classes.images}
              src='https://mcdn.bymason.com/runway/controller/empty-state-devices.svg'
              alt='When you add devices to the Mason platform, they will show up here'
            />
          }
          href='/controller/store'
          target='_blank'
          rel='noopener noreferrer'
        />
        <LinkCard
          message='View documentation'
          Component={
            <img
              className={classes.images}
              src='https://mcdn.bymason.com/runway/controller/empty-state-docs.svg'
              alt='Visit our documentation site'
            />
          }
          href='https://docs.bymason.com/setup-guide'
          target='_blank'
          rel='noopener noreferrer'
        />
        <LinkCard
          message='Devices intro'
          size='wide'
          Component={
            <div className={classes.background} title='Watch our devices page tutorial'>
              <IoPlayCircleOutline size={48} color='white' />
            </div>
          }
          onClick={handleOpenMedia}
        />
      </div>
      <Modal open={mediaOpen} onClose={handleCloseMedia} component='div'>
        <div className={classes.modalContent}>
          <iframe
            title='Devices'
            width='100%'
            height='100%'
            src='https://www.youtube-nocookie.com/embed/L2ZrvFUjI3o?autoplay=1&mute=1'
            frameBorder='0'
            allow='autoplay; encrypted-media'
            allowFullScreen={true}
          />
        </div>
      </Modal>
    </section>
  );
}
